import React from 'react'
import { styled } from '@mui/material/styles'
import { useRouter } from 'next/router'
import { AppBar, Container, Tabs, Tab } from '@mui/material'

const PREFIX = 'CompanyTabs'

const classes = {
  appBar: `${PREFIX}-appBar`,
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`&.${classes.appBar}`]: {
    backgroundColor: 'white',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}))

function CompanyTabs() {
  const router = useRouter()

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    router.push(newValue)
  }

  return (
    <StyledAppBar className={classes.appBar} position="static" elevation={0} variant="outlined">
      <Container maxWidth="md">
        <Tabs
          value={router.asPath}
          onChange={handleChange}
          centered={true}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="カタログ" value={`/company/${router.query.id}/catalog`} />
          <Tab label="会社概要" value={`/company/${router.query.id}/info`} />
        </Tabs>
      </Container>
    </StyledAppBar>
  )
}

export default CompanyTabs
